module.exports = __webpack_public_path__ + "img/46.9e66f247.jpg";